import { currentLanguage, localeOf, localized, useTranslation } from '@pos/i18n';
import { WEEKDAYS, type ColumnDef } from '../resources';
import { ReferenceLabel } from './ReferenceLabel';

/** A list cell, formatted by the column's type. */
export function CellValue({ column, value }: { column: ColumnDef; value: unknown }) {
  const { t } = useTranslation();
  if (value == null || value === '') return null;
  switch (column.type) {
    case 'toggle':
      return <>{t(value ? 'admin.yes' : 'admin.no')}</>;
    case 'select': {
      const option = column.options?.find((o) => String(o.value) === String(value));
      return <>{option ? t(option.label) : String(value)}</>;
    }
    case 'reference':
      return <ReferenceLabel resourceKey={column.ref} value={value} />;
    case 'localized':
      return <>{localized(value as Record<string, string>, '')}</>;
    case 'number':
    case 'decimal':
      return (
        <span className="pos-admin-page__number">
          {new Intl.NumberFormat(localeOf(currentLanguage())).format(Number(value))}
        </span>
      );
    case 'datetime':
      return <>{new Date(String(value)).toLocaleString(localeOf(currentLanguage()))}</>;
    case 'time':
      return <>{String(value).slice(0, 5)}</>;
    case 'weekdays': {
      const mask = Number(value);
      if ((mask & 127) === 127) return <>{t('admin.everyDay')}</>;
      return <>{WEEKDAYS.filter((_, index) => (mask & (1 << index)) !== 0).map((day) => t(`admin.weekdays.${day}`)).join(', ')}</>;
    }
    default:
      return <>{String(value)}</>;
  }
}
